module.exports = __webpack_public_path__ + "img/2.cd91e9f0.jpg";